import getConfig from "next/config";

const { publicRuntimeConfig } = getConfig();

interface Ads {
  [index: string]: { path: string; id?: string };
}
export const ads: Ads = {
  halfTakeover: {
    id: `div-gpt-ad-1614288008013-0`,
    path: `/13212770/home/half_takeover`,
  },
  searchLower: {
    id: `div-gpt-ad-1614288333655-0`,
    path: `/13212770/search/lower`,
  },
  searchUpper: {
    id: `div-gpt-ad-1614288137196-0`,
    path: `/13212770/search/upper`,
  },
  strainPhotosLower: {
    path: `/13212770/strain/photos_lower`,
  },
  strainPhotosUpper: {
    path: `/13212770/strain/photos_upper`,
  },
};

export const getAdPath = (tag: string) => {
  if (Object.keys(ads).indexOf(tag) !== -1) {
    return ads[tag].path;
    // could not find an ad for you, this is bad & we are going to fail loudly in dev
  } else if (publicRuntimeConfig.env !== "prod") {
    throw new Error(`Tried to place an add that was not configured: ${tag}`);
  }
};
